import React from "react";

export default function Strengths() {
    return (
        <section className="w-full max-w-5xl mx-auto py-12 px-4">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-2">
                Strengths
            </h2>

            {/* Grid of 4 category cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                {/* Backend */}
                <div className="bg-white rounded-2xl shadow-md p-6 hover:shadow-lg transition-all duration-300">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-2">Backend</h3>
                    <p className="text-gray-600 text-sm mb-4">
                        Building robust APIs and efficient server-side logic.
                    </p>
                    <div className="flex flex-wrap gap-2">
                        {[
                            ".NET Core",
                            "ASP.NET Web API",
                            "Entity Framework Core",
                            "C#",
                            "SQL Server",
                            "MVC",
                        ].map((skill) => (
                            <span
                                key={skill}
                                className="px-3 py-1 bg-[#E6E1DF] text-[#4A3F3C] rounded-lg text-sm font-medium shadow-sm"
                            >
                {skill}
              </span>
                        ))}
                    </div>
                </div>

                {/* Frontend */}
                <div className="bg-white rounded-2xl shadow-md p-6 hover:shadow-lg transition-all duration-300">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-2">Frontend</h3>
                    <p className="text-gray-600 text-sm mb-4">
                        Crafting responsive, user-friendly interfaces.
                    </p>
                    <div className="flex flex-wrap gap-2">
                        {["React", "JavaScript", "Tailwind CSS"].map((skill) => (
                            <span
                                key={skill}
                                className="px-3 py-1 bg-[#E6E1DF] text-[#4A3F3C] rounded-lg text-sm font-medium shadow-sm"
                            >
                {skill}
              </span>
                        ))}
                    </div>
                </div>

                {/* Dev Tools */}
                <div className="bg-white rounded-2xl shadow-md p-6 hover:shadow-lg transition-all duration-300">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-2">Dev Tools</h3>
                    <p className="text-gray-600 text-sm mb-4">
                        Tools I use to test, deploy, and collaborate efficiently.
                    </p>
                    <div className="flex flex-wrap gap-2">
                        {["Git", "Postman", "Docker", "Firebase"].map((tool) => (
                            <span
                                key={tool}
                                className="px-3 py-1 bg-[#E6E1DF] text-[#4A3F3C] rounded-lg text-sm font-medium shadow-sm"
                            >
                {tool}
              </span>
                        ))}
                    </div>
                </div>

                {/* Soft Skills */}
                <div className="bg-white rounded-2xl shadow-md p-6 hover:shadow-lg transition-all duration-300">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-2">Soft Skills</h3>

                    <div className="flex flex-wrap gap-2">
                        {["Clear communication", "Teamplayer", "Problem solver", "Ownership", "Growth Mindset"].map(
                            (skill) => (
                                <span
                                    key={skill}
                                    className="px-3 py-1 bg-[#E6E1DF] text-[#4A3F3C] rounded-lg text-sm font-medium shadow-sm"
                                >
                  {skill}
                </span>
                            )
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}
